// 调度日报
const dispatchTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: '工单类型',
        prop: 'orderType'
    },
    {
        label: '工单卸车点是否为推荐点',
        prop: 'dispatchWoFenceReachStdType'
    },
    {
        label: '实际卸车点是否为推荐点',
        prop: 'dispatchActionFenceReachStdType'
    },
    {
        label: '实际卸车量是否为推荐量',
        prop: 'dispatchActionCntReachStdType'
    },
    {
        label: '调度车辆数',
        prop: 'dispatchBikeCount'
    },
    {
        label: '调度后24小时内活跃车',
        prop: 'dispatchActiveBikeCountIn24H'
    },
    {
        label: '调度后24小时内活跃车占比',
        prop: 'dispatchActiveBikeRateIn24H'
    }
]

// 骑入骑出
const rideTable = [
    {
        label: '时间',
        prop: ''
    },
    {
        label: '城市',
        prop: ''
    },
    {
        label: '停车点名称',
        prop: ''
    },
    {
        label: '留存车数',
        prop: ''
    },
    {
        label: '实际调出车次',
        prop: ''
    },
    {
        label: '实际调入车次',
        prop: ''
    },
    {
        label: '骑出车次',
        prop: ''
    },
    {
        label: '骑入车次',
        prop: ''
    },
    {
        label: '停车点经度',
        prop: ''
    },
    {
        label: '停车点纬度',
        prop: ''
    },
]

// 调度评级
const dipatchPointTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: '运营围栏名称',
        prop: 'spockOpFenceName'
    },
    {
        label: '停车围栏名称',
        prop: 'fenceName'
    },
    {
        label: '24小时曝光车辆数',
        prop: 'exposeBikeCountIn24h'
    },
    {
        label: '骑出车24小时周转数',
        prop: 'rideOutBikeTurnoverRateIn24h'
    },
    {
        label: '围栏RR排名',
        prop: 'fenceRrRank'
    },
    {
        label: '围栏RR排名等级',
        prop: 'fenceRrRankLevel'
    },
]

// 调入推荐
const commendTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: '运营区名称',
        prop: 'opFenceName'
    },
    {
        label: '调入点名称',
        prop: 'fenceName'
    },
    {
        label: '调度日期',
        prop: 'dispatchExecuteDate'
    },
    {
        label: '推荐点位排名',
        prop: 'rank'
    },
    {
        label: '调入车辆数',
        prop: 'suggestBikeCount'
    }
]

// 调出推荐
const commendOutTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: '围栏名称',
        prop: 'parkingName'
    },
    {
        label: '健康车周转排名',
        prop: 'streetSplitBikeTurnoverRanking'
    },
    {
        label: '建议调出量',
        prop: 'loadNumSuggestion'
    }
]

// 调度收益
const dispatchProfitTable = [
    {
        label: '日期',
        prop: 'date',
        width: 100
    },
    {
        label: '城市',
        prop: 'regionName',
        width: 100
    },
    {
        label: '工单类型',
        prop: 'dispatchWoType'
    },
    {
        label: '工单ID',
        prop: 'dispatchWoDd'
    },
    {
        label: '车辆ID',
        prop: 'bikeId'
    },
    {
        label: '工单创建时间',
        prop: 'dispatchCreateTime',
        width: 100
    },
    {
        label: '装车围栏名称',
        prop: 'loadFenceName',
        width: 100
    },
    {
        label: '卸车围栏名称',
        prop: 'unloadFenceName',
        width: 100
    },
    {
        label: '装车时间',
        prop: 'loadTime',
        width: 100
    },
    {
        label: '卸车时间',
        prop: 'unloadTime',
        width: 100
    },
    {
        label: '调度后24小时订单',
        prop: 'sumRevenueTurnoverRate24h',
        width: 150
    },
    {
        label: '预计不调度24小时订单',
        prop: 'sumOpptyTurnoverRate24h',
        width: 150
    },
    {
        label: '预计调度后24小时订单增长',
        prop: 'sumIncreaseTurnoverRate24h',
        width: 170
    }
]

// 换电日报
const batteryDailyTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: '低电扫码次数',
        prop: 'scanLowPowerNum'
    },
    {
        label: '总扫码次数',
        prop: 'totalScanTimes'
    },
    {
        label: '低电扫码率',
        prop: 'scanLowPowerRate'
    },
    {
        label: '低电流失订单',
        prop: 'orderMissNumWithLowPower'
    },
    {
        label: '应完成换电量',
        prop: 'shouldNumPowerExchange'
    },
    {
        label: '总换电量',
        prop: 'totalChangeValue'
    },
    {
        label: '应换完成率',
        prop: 'shouldRatePowerExchange'
    },
    {
        label: '常规换电人数',
        prop: 'normalPowerExchangeNum'
    },
    {
        label: '换电人效',
        prop: 'effectivePowerExchangeNum'
    }
]

// 换电详情
const batteryDetailTable = [
    {
        label: '日期',
        prop: 'date'
    },
    {
        label: '城市',
        prop: 'regionName'
    },
    {
        label: 'bike_id',
        prop: 'bikeId'
    },
    {
        label: '换电记录ID',
        prop: 'powerExchangeRecordId'
    },
    {
        label: '换电人',
        prop: 'powerExchangePersonName'
    },
    {
        label: '换电时间',
        prop: 'powerExchangeDate'
    },
    {
        label: '原电池电量占比(%)',
        prop: 'powerBeforeExchange'
    },
    {
        label: '当前电池电量占比(%)',
        prop: 'powerAfterExchange'
    }
]

export {
    dispatchTable,
    rideTable,
    dipatchPointTable,
    commendTable,
    commendOutTable,
    dispatchProfitTable,
    batteryDailyTable,
    batteryDetailTable
}